module.exports = __webpack_public_path__ + "static/media/Logout.f1d2aeea.svg";